import React, { useEffect, useRef, useState } from "react";
import styles from "./PhoneInputComponent.module.scss";
import { NumberPrefix } from "../../../services/phonePrefix.service";

interface PhoneInputProps {
  label: string | undefined;
  id: string;
  name: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCodeChange: (code: string) => void;
  error?: string;
  disabled?: boolean;
  readOnly?: boolean;
  selectedCode?: string;
  combinePrefixWithNumber?: boolean;
  maxLength?: number;
}

const PhoneInputComponent: React.FC<PhoneInputProps> = ({
  label,
  id,
  name,
  placeholder,
  value,
  onChange,
  onCodeChange,
  error,
  disabled,
  maxLength,
  selectedCode: initialSelectedCode = "50",
  combinePrefixWithNumber = false,
}) => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [selectedCode, setSelectedCode] = useState(initialSelectedCode);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setInputValue(value);
    setSelectedCode(initialSelectedCode);
  }, [value, initialSelectedCode]);
  useEffect(() => {
    setSelectedCode(initialSelectedCode);
  }, [initialSelectedCode]);

  interface Prefix {
    id: string;
    prefix: string;
  }

  const [codeNumbers, setCodeNumbers] = useState<Prefix[]>([]);

  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    NumberPrefix.getAllPrefix().then((res) => {
      setCodeNumbers(res.data.data);
    });
    setInputValue(value);
  }, []);

  const handleOptionSelect = (code: string) => {
    setSelectedCode(code);
    onCodeChange(code);
    setDropdownVisible(false);

    if (combinePrefixWithNumber) {
      onChange({
        target: {
          name,
          value: code + inputValue,
        },
      } as React.ChangeEvent<HTMLInputElement>);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);

    if (combinePrefixWithNumber) {
      onChange({
        target: {
          name,
          value: selectedCode + newValue,
        },
      } as React.ChangeEvent<HTMLInputElement>);
    } else {
      onChange({
        target: {
          name,
          value: newValue,
        },
      } as React.ChangeEvent<HTMLInputElement>);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDropdownToggle = () => {
    if (disabled) return;
    setDropdownVisible((prev) => !prev);
  };

  return (
    <div ref={dropdownRef} className={styles.phoneInput}>
      <label className={styles.labelInput} htmlFor={id}>
        {label}
      </label>
      <div className={styles.phoneInputGroup}>
        <div
          className={`${styles.phoneCodeSelect} ${disabled ? styles.disabled : ""
            }`}
          onClick={handleDropdownToggle}
        >
          {selectedCode}
        </div>
        {isDropdownVisible && (
          <div className={styles.phoneCodeDropdown}>
            {codeNumbers.map((code) => (
              <div
                key={code.id}
                className={styles.option}
                onClick={() => handleOptionSelect(code.prefix)}
              >
                {code.prefix}
              </div>
            ))}
          </div>
        )}
        <input
          type="text"
          id={id}
          name={name}
          placeholder={placeholder}
          className={styles.liveSupportFormInput}
          value={inputValue}
          onChange={handleInputChange}
          disabled={disabled}
          maxLength={7}
          autoComplete="off"

        />
      </div>
      {error && <p className={styles.error_message}>{error}</p>}
    </div>
  );
};

export default PhoneInputComponent;
